import type { DietGoal } from "@couples/shared";

import { supabase } from "../supabase";

interface GoalRow {
  user_id: string;
  couple_id: string;
  start_weight: number | string;
  goal_weight: number | string;
  started_on: string;
  due_on: string | null;
}

const COLUMNS = "user_id, couple_id, start_weight, goal_weight, started_on, due_on";

function numberOf(value: number | string): number {
  return typeof value === "number" ? value : Number(value);
}

function toGoal(row: GoalRow): DietGoal {
  return {
    userId: row.user_id,
    coupleId: row.couple_id,
    startWeight: numberOf(row.start_weight),
    goalWeight: numberOf(row.goal_weight),
    startedOn: row.started_on,
    dueOn: row.due_on,
  };
}

/** 二人ぶんの目標。まだ決めていない人の行は無い(0〜2件) */
export async function fetchGoals(): Promise<DietGoal[]> {
  const { data, error } = await supabase.from("diet_goals").select(COLUMNS);
  if (error) throw error;
  const rows: GoalRow[] = data;
  return rows.map(toGoal);
}

export interface DietGoalInput {
  startWeight: number;
  goalWeight: number;
  /** `YYYY-MM-DD` */
  startedOn: string;
  dueOn: string | null;
}

/**
 * 自分の目標を決める(決め直す)。1人1行なので upsert。
 * user_id / couple_id は DB 側の既定値でセッションから埋まる。相手の行は RLS が弾く。
 */
export async function saveGoal(input: DietGoalInput): Promise<void> {
  const { error } = await supabase.from("diet_goals").upsert(
    {
      start_weight: input.startWeight,
      goal_weight: input.goalWeight,
      started_on: input.startedOn,
      due_on: input.dueOn,
      updated_at: new Date().toISOString(),
    },
    { onConflict: "user_id" },
  );
  if (error) throw error;
}
